import script from "./ReportDeliveryMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportDeliveryMain.vue?vue&type=script&setup=true&lang=js"

import "./ReportDeliveryMain.vue?vue&type=style&index=0&id=177464f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-177464f2"]])

export default __exports__